import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/employee-management-system/employee-directory/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "employee-directory" entry is kept); the seo block below is a fallback.

export const employeeDirectory: ContentPage = {
  slug: "employee-management-system/employee-directory",
  template: "hrmsFeature",
  seo: {
    title: "Centralized Employee Directory for Efficient HR Operations",
    description: "Manage employee profiles, roles, and documents in one secure directory. Keep your data organized and easily accessible for your HR needs.",
    keywords: [
      "employee directory",
      "staff directory software",
      "employee profile management",
      "HR directory system",
      "employee record-keeping software",
      "employee database",
      "employee management system.",
    ],
    ogImage: "/assets/data/seoimages/employee-directory.webp",
  },
  leaf: {
    hero: {
      caption: "Employee Directory",
      title: "Centralized Employee Directory for Seamless Management",
      description: "Easily manage employee profiles, personal details, roles, and contact information in a secure and centralized directory for streamlined operations.",
      h1: "caption",
    },
    split: {
      title: "Comprehensive Employee Information in One Place",
      bullets: [
        { title: "Profile Creation", description: "Create and manage individual employee profiles." },
        { title: "Document Storage", description: "Upload and manage important documents." },
        { title: "Search and Filter", description: "Efficiently locate detailed employee information." },
        { title: "Role Assignments", description: "Assign roles and permissions based on job functions." },
      ],
      image: "/assets/images/img/product/hrms/employeems/employee-directory_image.webp",
      imageAlt: "employee directory info",
    },
    cardsHeading: {
      title: "Key Features of Employee Management System",
      description: "Optimize Employee management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Attendance Tracking",
        href: "/hrms-software/employee-management-system/attendance-tracking",
        description: "Track and monitor employee attendance with real-time clock-in/out, ensuring precise records for improved productivity and payroll accuracy.",
        image: "/assets/images/img/product/hrms/employeems/attendance_tracking_images.webp",
        imageAlt: "attendance_tracking_key_features",
      },
      {
        title: "Performance Review",
        href: "/hrms-software/employee-management-system/performance-review",
        description: "Track employee performance, set KPIs, and provide feedback with structured review processes for better productivity and growth.",
        image: "/assets/images/img/product/hrms/employeems/performance_review.webp",
        imageAlt: "performance_review",
      },
      {
        title: "Leave Management",
        href: "/hrms-software/employee-management-system/leave-management",
        description: "Simplify leave requests and approvals with automated workflows, ensuring smooth operations and minimal disruptions.",
        image: "/assets/images/img/product/hrms/employeems/leave_management.webp",
        imageAlt: "leave_management",
      },
      {
        title: "Shift Management",
        href: "/hrms-software/employee-management-system/employee-shift-management",
        description: "Automate and organize shift scheduling, manage shift swaps, and ensure proper staffing with a powerful shift management system.",
        image: "/assets/images/img/product/hrms/employeems/shift_management.webp",
        imageAlt: "shift_management",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Take Control of Your Employee Data Today!",
    relatedBlogs: "static",
    metaKey: "employee-directory",
  },
  sections: [],
};
